import React from "react";
import { Link } from "react-router-dom";
import "./LoungeDetail.css";

const AMENITIES = [
  { emoji: "🍽️", label: "Food & Snacks" },
  { emoji: "🥂", label: "Bar" },
  { emoji: "📶", label: "WiFi" },
  { emoji: "🚿", label: "Shower" },
  { emoji: "💺", label: "Rest Area" },
  { emoji: "📰", label: "Press" },
  { emoji: "🔌", label: "Charging" },
];

const HOW_TO_USE = [
  "Open the Visa Airport Companion app or visit loungekey.com/etoro",
  "Search for lounges at your departure airport",
  "Show your eToro Visa card + QR code at the lounge entrance",
  "Enjoy complimentary food, drinks, WiFi, showers, and relaxation",
];

const NEARBY_LOUNGES = [
  { name: "El Al King David Lounge", distance: "120m", status: "Open", open: true },
  { name: "Fattal Premium Lounge", distance: "280m", status: "Open", open: true },
  { name: "Dan Business Lounge", distance: "450m", status: "Closed", open: false },
];

export default function LoungeDetail() {
  return (
    <div className="lounge-detail">
      <header className="lounge-detail-header">
        <Link to="/lounges" className="lounge-detail-back" aria-label="Back to lounges">
          ←
        </Link>
      </header>

      <h1 className="lounge-detail-title">Dan Lounge</h1>
      <p className="lounge-detail-subtitle">Terminal 3</p>

      <div className="lounge-detail-stats">
        <span className="stat-pill">⭐ 4.2</span>
        <span className="stat-pill">Open 24h</span>
        <span className="stat-pill">150 seats</span>
      </div>

      <section className="lounge-detail-section">
        <h2 className="section-title">Amenities</h2>
        <div className="amenities-grid">
          {AMENITIES.map((a, i) => (
            <span key={i} className="amenity-chip">
              <span className="icon-lean">{a.emoji}</span> {a.label}
            </span>
          ))}
        </div>
      </section>

      <section className="lounge-detail-section">
        <h2 className="section-title">How to Use</h2>
        <div className="how-to-use-steps">
          {HOW_TO_USE.map((step, i) => (
            <div key={i} className="how-to-use-step">
              <span className="how-to-use-num">{i + 1}</span>
              <span className="how-to-use-text">{step}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="lounge-detail-section">
        <h2 className="section-title">Location</h2>
        <p className="location-text">
          Departures level, after security checkpoint, Gate B12-B24 area
        </p>
      </section>

      <section className="lounge-detail-section">
        <h2 className="section-title">Nearby — Ben Gurion Airport</h2>
        <div className="nearby-lounges">
          {NEARBY_LOUNGES.map((lounge, i) => (
            <div key={i} className="nearby-lounge-item">
              <div className="nearby-lounge-left">
                <svg className="nearby-pin" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <div className="nearby-lounge-info">
                  <span className="nearby-lounge-name">{lounge.name}</span>
                  <span className="nearby-lounge-distance">{lounge.distance}</span>
                </div>
              </div>
              <span className={`nearby-lounge-status ${lounge.open ? "open" : "closed"}`}>
                {lounge.status}
              </span>
            </div>
          ))}
        </div>
      </section>

      <section className="lounge-detail-section">
        <h2 className="section-title">Reviews</h2>
        <blockquote className="review-block">
          <span className="review-stars">⭐⭐⭐⭐</span>
          <p className="review-text">
            "Great food, comfortable seating. Showers are clean."
          </p>
          <cite className="review-cite">— Traveler, Mar 2026</cite>
        </blockquote>
      </section>

      <Link to="/lounges/dan-lounge/pass" className="lounge-detail-cta">
        Generate Pass
      </Link>
    </div>
  );
}
